module.exports = __webpack_public_path__ + "img/kyc2-bg.6246a3a1.png";